export class UtilsService {
    shortenAddress = (address: string, chars = 5): string => {
        return `${address.slice(0, chars)}...${address.slice(-chars)}`;
    };
}
export default new UtilsService()